import { Link } from 'react-router-dom'; // react-router **dom**
import SideBar from '../../components/global/SideBar';
import './index.css';

export default function Membership() {

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto p-6">
        <div className="text-black text-8xl font-bold mb-4">wellness history</div>
        <Link className="text-black underline" to="/partners">
          Partners
        </Link>
        <div className="mt-10 text-black">
          {[...Array(100)].map((_, i) => (
            <p key={i}>Line {i + 1}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
